import { useState, useCallback } from 'react';
import { API_URL } from '../utils/api';
import { useAuth } from '../contexts/AuthContext';

export const useNotifications = () => {
  const { getAuthHeaders } = useAuth();
  const [notifications, setNotifications] = useState([]);

  const fetchNotifications = useCallback(async () => {
    try {
      const response = await fetch(`${API_URL}/notifications`, {
        headers: getAuthHeaders()
      });
      
      if (!response.ok) {
        console.error('Authentication failed:', response.status);
        setNotifications([]);
        return;
      }
      
      const data = await response.json();
      
      if (Array.isArray(data)) {
        setNotifications(data);
      } else {
        setNotifications([]);
      }
    } catch (error) {
      console.error('Error fetching notifications:', error);
      setNotifications([]);
    }
  }, [getAuthHeaders]);

  return {
    notifications,
    setNotifications,
    fetchNotifications
  };
};
